/**
 * Feature flags for backend capabilities JurorQuestionnaire.Api hasn't implemented yet.
 * See JurorQuestionnaire.Api/README.md ("What's deliberately deferred") in the
 * icon.web.justice360nextgen repo for the authoritative status.
 *
 * These are hardcoded rather than detected at runtime (e.g. by probing for a 404) so the
 * UI degrades predictably and can be flipped back on with a one-line change per feature
 * once the corresponding endpoint exists, instead of every user hitting a failed request
 * before the UI knows to hide itself.
 */
export const BACKEND_FEATURES = {
  /** GET /tenants - no multi-tenant concept exists in the legacy schema yet. */
  tenants: false,
  /** GET /court-types and GET/PUT /questionnaires/{slug}/assignment. */
  courtTypeAssignment: false,
  /**
   * PATCH /questionnaires/{slug} ({ isActive }) - implemented via EffectiveFromDate/
   * EffectiveToDate on the backend (see BuilderQuestionnaireAdapter.SetActive/
   * IsQuestionnaireActive); there's no dedicated IsActive column.
   */
  isActiveToggle: true,
  /**
   * PUT /questionnaires/{id} only honors a client-chosen id when it matches an existing
   * questionnaire; creating under a new id always gets a server-assigned numeric id instead
   * (no Slug column exists yet). useCreateQuestionnaire already accounts for this by using
   * the id the server returns rather than the one requested - this flag just documents why.
   */
  clientChosenSlugOnCreate: false,
} as const;
